module.exports = __webpack_public_path__ + "img/step2.c752ba98.png";